<template>
	<SurveyScreen v-bind="surveyData" />
</template>

<script setup>
import { reactive } from '@vue/runtime-core'
import SurveyScreen from '@/components/SurveyScreen'

const surveyData = reactive({
	title: 'What typically triggers your urge to snack or nibble?',
	property: 'snack_trigger',
	options: [
		{ id: 1, label: 'Boredom', value: 'boredom' },
		{ id: 2, label: 'Hunger', value: 'hunger' },
		{ id: 3, label: 'Having food around me', value: 'having_food_around_me' },
		{ id: 4, label: 'Other people snacking', value: 'other_people_snacking' },
		{ id: 5, label: 'Something else', value: 'something_else' }
	],
	eventView: 'OnboardingSnackTriggerScreen',
	eventDone: 'OnboardingSnackTriggerScreenDone',
	nextRouteName: 'emotional-eating-course-intro',
	skip: {
		text: 'None of the above',
		key: 'none'
	}
})
</script>
